module.exports = __webpack_public_path__ + "media/images/spree/frontend/icons/arrow/dark/long-left-c7926193f26d624352e9231517f1af4c.png";